import { Column } from '@/presentation/components/table';
import { columns as baseColumns } from '@/domain/env/colums-base';
import { CollectionBase } from '@/domain/types/collections';
import { ALL_AUDIENCE, Audience } from '@/domain/types/audience';

const isRestricted = (row: CollectionBase) =>
  !!row.audienceIds?.length && !row.audienceIds.includes(ALL_AUDIENCE);

/**
 * Construye las columnas de Última Hora: las columnas base compartidas
 * (title, description, createdAt, views, downloads, favorites, comments,
 * documentUrl — usadas también por newsletters y policies, ver colums-base.tsx)
 * más una columna de audiencia exclusiva de releases. No se modifica
 * colums-base.tsx para no afectar a esas otras páginas.
 */
export function buildReleaseColumns(audiences: Audience[]): Column<CollectionBase>[] {
  const audienceLabel = (row: CollectionBase): string => {
    const audienceIds = row.audienceIds;
    if (!audienceIds || audienceIds.length === 0) return 'General';
    if (audienceIds.includes(ALL_AUDIENCE)) return 'General';
    return audienceIds
      .map((id) => audiences.find((a) => a.id === id)?.name ?? id)
      .join(', ');
  };

  const audienceColumn: Column<CollectionBase> = {
    header: 'Audiencia',
    accessor: 'audienceIds',
    render: (_value, row) => (
      <span
        className={
          isRestricted(row)
            ? 'px-2 py-1 rounded text-xs bg-amber-100 text-amber-800'
            : 'px-2 py-1 rounded text-xs bg-gray-100 text-gray-700'
        }
      >
        {audienceLabel(row)}
      </span>
    ),
  };

  return [...baseColumns, audienceColumn];
}
